/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectDailyTaskReportByContractorCommand } from '../../models/update-project-daily-task-report-by-contractor-command';
import { UpdateProjectDailyTaskReportByContractorCommandResult } from '../../models/update-project-daily-task-report-by-contractor-command-result';

export interface ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Params {
      body?: UpdateProjectDailyTaskReportByContractorCommand
}

export function apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskReportByContractorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectDailyTaskReportByContractorCommandResult>;
    })
  );
}

apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch.PATH = '/api/ProjectDailyTaskReports/UpdateProjectDailyTaskReportByContractor';
